export const filters: Array<string> = [
    'agentId',
    'rating',
    'solo',
    'group',
    'arrivalDateFrom',
    'arrivalDateTo',
    'requestDateFrom',
    'requestDateTo',
    'actionType',
    'market',
    'destination',
    'minBudget',
    'maxBudget',
    'TA',
];
